var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 362.42 92.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#0571dc;}.cls-2,.cls-6,.cls-7,.cls-8{fill:#0b3c64;}.cls-3{fill:#0972dd;}.cls-4{font-size:70.85px;fill:#0c7fda;font-family:GothamRounded-Medium, GothamRounded Medium;font-weight:500;letter-spacing:-0.18em;}.cls-5{letter-spacing:-0.06em;}.cls-6{letter-spacing:-0.07em;}.cls-7{letter-spacing:-0.06em;}.cls-8{letter-spacing:-0.07em;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.19,57.16a54.83,54.83,0,0,0,8.49,11.29C26.73,84,54.37,82.31,68.29,64.79,72.88,59,72.8,53,67.75,47.58a35.62,35.62,0,0,1-9-18.5,11.31,11.31,0,0,1,.21-6.1c.32-.86.66-1.58,1.71-1.65a2,2,0,0,1,2,1.41c.61,1.32,1.09,2.71,1.6,4.08.69,1.84,1.31,3.72,2.05,5.54.6,1.48,1.35,2.92,3.36,2.46,1.84-.42,2.63-1.74,2.85-3.54a18.52,18.52,0,0,0-.84-8.4c-2.8-7.93-7-14.75-15.16-18.27a4.43,4.43,0,0,1-1.28-.86c-.88-.81-2.07-1.74-1.48-3s2-.55,3-.32C66.1,2.55,73,8.22,77.63,16.34c7.56,13.31,10.21,27.76,7.15,42.82C81.51,75.25,71.39,85.63,55.83,90.38A42.13,42.13,0,0,1,2,57.64C2,57.57,2,57.49,2.19,57.16Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11,28.48c-6.68.19-10.8-3-11-8.43a8.68,8.68,0,0,1,8.43-9.2c5.83-.16,9,3.54,9.3,11q16.4-10.31,32.8-.09C43,20,35.69,20.25,28.84,24.33A26.22,26.22,0,0,0,16,42.16c-2.46,11.8,3.47,27,20.81,31.62-7.31,1.78-18.68-2.58-24.12-9.5C3.67,52.81,3.41,40.81,11,28.48Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M70.87,28C68.11,22.52,65,17.45,59.8,14a25.62,25.62,0,0,0-3.4-1.79,5.54,5.54,0,0,1-2.79-2.56c-.53-1.08-.43-2.31,1.14-2,3.33.63,6.72,1,9.12,4.11C67.65,16.57,70.54,21.69,70.87,28Z"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(105.13 72.1) scale(0.99 1)"
  }, "F", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-5",
    x: 21.75,
    y: 0
  }, "ocus"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 142.48,
    y: 0
  }, "C"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 178.83,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 208.73,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 226.94,
    y: 0
  }, "e"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.2302ac8e3bf8ac582d6b0b3cdf123070.svg";
export { ForwardRef as ReactComponent };